module.exports = __webpack_public_path__ + "static/media/frame.5c8a94f4.png";